import React from "react";
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";

interface AccountCardProps {
  account: any;
  isMenu: any;
  toggleMenu: any;
  onViewClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

export const AccountCard = ({
  account,
  isMenu,
  toggleMenu,
  onViewClick,
  onEditClick,
  onDeleteClick,
}: AccountCardProps) => {
  console.log("Account: ", account);
  return (
    <Card>
      <CardBody>
        <div className="d-flex">
          <div className="flex-shrink-0 me-4">
            <i className="mdi mdi-account-circle text-primary h1" />
          </div>

          <div className="flex-grow-1">
            <div className="text-muted">
              <h5>{account?.name}</h5>
              <p className="mb-1">{account?.account_number}</p>
              <p className="mb-0">Id no: {account?.id}</p>
            </div>
          </div>
          <Dropdown
            isOpen={isMenu}
            toggle={toggleMenu}
            direction="end"
            className="ms-2"
          >
            <DropdownToggle tag="a">
              <i className="mdi mdi-dots-horizontal font-size-18" />
            </DropdownToggle>
            <DropdownMenu>
              {onViewClick && (
                <DropdownItem
                  // href="#"
                  className="text-info"
                  onClick={onViewClick}
                >
                  <i className="mdi mdi-eye me-2" /> View
                </DropdownItem>
              )}
              {onEditClick && (
                <DropdownItem
                  // href={`/edit-account/${account.id}`}
                  className="text-success"
                  onClick={onEditClick}
                >
                  <i className="mdi mdi-pencil me-2" /> Edit
                </DropdownItem>
              )}
              {onDeleteClick && (
                <DropdownItem
                  // href="#"
                  className="text-danger"
                  onClick={onDeleteClick}
                >
                  <i className="mdi mdi-delete me-2" /> Delete
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        </div>
      </CardBody>
      <CardBody className="border-top">
        <Row>
          <Col sm="6">
            <div>
              <p className="text-muted mb-2">Available Balance</p>
              <h5>
                {account?.currency} {account?.available_balance}
              </h5>
            </div>
          </Col>
          <Col sm="6">
            <div className="text-sm-end mt-4 mt-sm-0">
              <p className="text-muted mb-2">Balance</p>
              <h5>
                {account?.currency} {account?.balance}
              </h5>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
